import * as React from 'react';
import ReactImageMagnify from 'react-image-magnify';

type ImageModalProps = {
  isOpen: boolean;
  imgSrc: string;
  onClose: () => void;
};

type ImageModalState = {
  naturalWidth: number;
  naturalHeight: number;
  zoomWidth: number;
  zoomHeight: number;
  isZoomEnabled: boolean;
};

class ImageModal extends React.Component<ImageModalProps, ImageModalState> {
  constructor(props: ImageModalProps) {
    super(props);
    this.state = {
      naturalWidth: 0,
      naturalHeight: 0,
      zoomWidth: 0,
      zoomHeight: 0,
      isZoomEnabled: true,
    };
  }

  componentDidMount() {
    this.updateImageDimensions(this.props.imgSrc);
  }

  componentDidUpdate(prevProps: ImageModalProps) {
    if (this.props.imgSrc !== prevProps.imgSrc) {
      this.updateImageDimensions(this.props.imgSrc);
    }
  }

  handleImageClick = (event: React.MouseEvent<HTMLDivElement>) => {
    // Prevent the click from propagating to the modal's background
    event.stopPropagation();
};



updateImageDimensions = (src: string) => {
    const img = new Image();
    img.onload = () => {
        const minWidthThreshold = 400; 
        const minHeightThreshold = 400; 
        const isZoomEnabled = img.naturalWidth >= minWidthThreshold && img.naturalHeight >= minHeightThreshold;

        let zoomWidth, zoomHeight;
        if (isZoomEnabled) {
            // Apply a scaling factor for eligible images to enhance the zoom effect
            const scaleFactor = 2;
            zoomWidth = img.naturalWidth * scaleFactor;
            zoomHeight = img.naturalHeight * scaleFactor;
        } else {
            console.log('Image too small for zoom.');
            zoomWidth = img.naturalWidth;
            zoomHeight = img.naturalHeight;
        }

        this.setState({
            naturalWidth: img.naturalWidth, // Store the actual natural dimensions
            naturalHeight: img.naturalHeight,
            zoomWidth, // Dimensions used for zoom
            zoomHeight,
            isZoomEnabled,
        });
    };
    img.src = src;
};


    render() {
        const { isOpen, imgSrc, onClose } = this.props;
        const { isZoomEnabled } = this.state;

        if (!isOpen) return null;

        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
            }} onClick={onClose}>
                <div onClick={(e) => e.stopPropagation()} style={{backgroundColor: 'white'}}>
                    {isZoomEnabled ? (
                    <ReactImageMagnify 
                    {...{
                        smallImage: {
                            alt: "Enlarged",
                            isFluidWidth: true,
                            src: imgSrc,
                        },
                        largeImage: {
                            src: imgSrc,
                            width: this.state.zoomWidth,
                            height: this.state.zoomHeight,
                        },
                        enlargedImagePosition: "over",
                    }} 
                />
                    ) : (
                        <img 
                            src={imgSrc} 
                            alt="Enlarged" 
                            style={{
                                maxWidth: '90vw',
                                maxHeight: '80vh',
                                width: 'auto',
                                height: 'auto',
                                display: 'block', // This makes sure the image is centered
                            }} 
                        />
                    )}
                    <button onClick={onClose} style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        cursor: 'pointer',
                        background: 'transparent',
                        border: 'none',
                        color: 'white',
                        fontSize: '24px',
                    }}>
                        &#10005;
                    </button>
                </div>
            </div>
        );
    }

}
export default ImageModal;